export const BASE_URL ="https://sjcscholarflow.com"
// export const BASE_URL ="https://demo.sjcscholarflow.com"
// export const BASE_URL = "http://localhost:8000";




// ============================================================================

// Dashboards
export const APIStudentDashboard = `${BASE_URL}/api/student-dashboard`;
export const APIInstitutionAdminDashboard = `${BASE_URL}/api/institution-admin-dashboard`;
export const APISupervisorSpecialtyDashboard = `${BASE_URL}/api/supervisor-dashboard/specialties`;
export const APIPlatformDashboard = `${BASE_URL}/api/platform-dashboard/list`;
export const APIInstitutionHeadDashboard = `${BASE_URL}/api/institution-head/dashboard`;
// Settings Users
export const APIUserStore = BASE_URL+"/api/user/store";
export const APIUserList = BASE_URL+"/api/user/list";
export const APIUserNames = BASE_URL+"/api/user/names";
export const APIUserProfileImage = BASE_URL+"/api/user/profile-image/";
export const APIUserUpdatePassword = BASE_URL+"/api/user/update-password";
export const APIUserProfileById = BASE_URL+"/api/user/profile-by-id";
export const APIUserUpdateProfile = BASE_URL+"/api/user/update-profile";
export const APIUserLogin = BASE_URL+"/api/user/login";
export const APIUserLogout = BASE_URL+"/api/user/logout";
export const APIUserUpdate = BASE_URL+"/api/user/update";
export const APIUserDelete = BASE_URL+"/api/user/delete";


// Permission APIs
export const APIPermissionList = BASE_URL + "/api/permission/list";
export const APIPermissionStore = BASE_URL + "/api/permission/store";
export const APIPermissionUpdate = BASE_URL + "/api/permission/update";
export const APIPermissionDelete = BASE_URL + "/api/permission/delete";

// University APIs
export const APIUniversityList = BASE_URL + "/api/university/list";
export const APIUniversityNames = BASE_URL + "/api/university/names";
export const APIUniversityStore = BASE_URL + "/api/university/store";
export const APIUniversityShow = BASE_URL + "/api/university/show/";
export const APIUniversitySchools = BASE_URL + "/api/university/schools";
export const APIUniversityUpdate = BASE_URL + "/api/university/update";
export const APIUniversityDelete = BASE_URL + "/api/university/delete";

// Specialty APIs
export const APISpecialtyList = BASE_URL + "/api/specialty/list";
export const APISpecialtyNames = BASE_URL + "/api/specialty/names";
export const APISpecialtyStore = BASE_URL + "/api/specialty/store";
export const APISpecialtyShow = BASE_URL + "/api/specialty/show/";
export const APISpecialtyUpdate = BASE_URL + "/api/specialty/update";
export const APISpecialtyDelete = BASE_URL + "/api/specialty/delete";
export const APISpecialtyByInstitution = BASE_URL + "/api/specialty/by-institution";
export const APISpecialtyByInstitutionAdmin = BASE_URL + "/api/specialty/by-institution-admin";

// Supervisor Specialties APIs
export const APISupervisorSpecialties = BASE_URL + "/api/supervisor-specialties/list";
export const APISupervisorSpecialtiesAvailable = BASE_URL + "/api/supervisor-specialties/available";
export const APISupervisorSpecialtyStore = BASE_URL + "/api/supervisor-specialties/store";
export const APISupervisorSpecialtyUpdate = BASE_URL + "/api/supervisor-specialties/update";
export const APISupervisorSpecialtyDelete = BASE_URL + "/api/supervisor-specialties/delete";

// Supervisor Universities APIs
export const APISupervisorInstitutionList = BASE_URL + "/api/supervisor-universities/list";
export const APISupervisorInstitutionStore = BASE_URL + "/api/supervisor-universities/store";
export const APISupervisorInstitutionUpdate = BASE_URL + "/api/supervisor-universities/update";
export const APISupervisorInstitutionDelete = BASE_URL + "/api/supervisor-universities/delete";

// Student APIs
// src/apiServices/APIs.js

// Base URL

// Student APIs
export const APIStudentRegister = `${BASE_URL}/api/student/register`;
export const APIStudentLogin = `${BASE_URL}/api/student/login`;
export const APIStudentDelete = `${BASE_URL}/api/student/delete`;
export const APIStudentUpdate = `${BASE_URL}/api/student/update`;
export const APIStudentList = `${BASE_URL}/api/student/list`;
export const APIStudentProfileById = `${BASE_URL}/api/student/profile-by-id`;
export const APIStudentUpdateProfile = `${BASE_URL}/api/student/update-profile`;
export const APIStudentCompleteProfile = `${BASE_URL}/api/student/complete-profile`;
export const APIStudentLogout = `${BASE_URL}/api/student/logout`;
export const APIStudentProfileCompletion = `${BASE_URL}/api/student/profile-completion`;
export const APIStudentProfileImage = BASE_URL+"/api/student/profile-image/";
export const APIStudentUpdatePassword = BASE_URL+"/api/student/update-password";
export const APIStudentUpdatePasswordByAdmin = BASE_URL+"/api/student/update-password-by-admin";


export const APIStudentVerifyEmail = `${BASE_URL}/api/student/verify-email`;
export const APIStudentResendVerification = `${BASE_URL}/api/student/resend-verification`;
export const APIStudentForgotPassword = `${BASE_URL}/api/student/forgot-password`;
export const APIStudentResetPassword = `${BASE_URL}/api/student/reset-password`;
export const APIStudentVerifyResetToken = `${BASE_URL}/api/student/verify-reset-token`;

// Supervisor APIs
export const APISupervisorRegister = BASE_URL + "/api/supervisor/register";
export const APISupervisorList = BASE_URL + "/api/supervisor/list";
export const APISupervisorDelete = BASE_URL + "/api/supervisor/delete";
export const APISupervisorLogin = BASE_URL + "/api/supervisor/login";
export const APISupervisorProfileById = BASE_URL + "/api/supervisor/profile-by-id";
export const APISupervisorUpdate = BASE_URL + "/api/supervisor/update";
export const APISupervisorProfileCompletion = BASE_URL + "/api/supervisor/profile-completion";
export const APISupervisorLogout = BASE_URL + "/api/supervisor/logout";
export const APISupervisorProfileImage = BASE_URL+"/api/supervisor/profile-image/";
export const APISupervisorUpdatePassword = BASE_URL+"/api/supervisor/update-password";
export const APISupervisorUpdatePasswordByAdmin = BASE_URL+"/api/supervisor/update-password-by-admin";



export const APISupervisorVerifyEmail = `${BASE_URL}/api/supervisor/verify-email`;
export const APISupervisorResendVerification = `${BASE_URL}/api/supervisor/resend-verification`;
export const APISupervisorForgotPassword = `${BASE_URL}/api/supervisor/forgot-password`;
export const APISupervisorResetPassword = `${BASE_URL}/api/supervisor/reset-password`;
export const APISupervisorVerifyResetToken = `${BASE_URL}/api/supervisor/verify-reset-token`;



// institution Admin APIs
export const APIInstitutionAdminRegister = BASE_URL + "/api/institution-admin/register";
export const APIInstitutionAdminLogin = BASE_URL + "/api/institution-admin/login";
export const APIInstitutionAdminProfileById = BASE_URL + "/api/institution-admin/profile-by-id";
export const APIInstitutionAdminUpdate = BASE_URL + "/api/institution-admin/update";
export const APIInstitutionAdminProfileCompletion = BASE_URL + "/api/institution-admin/profile-completion";
export const APIInstitutionAdminLogout = BASE_URL + "/api/institution-admin/logout";
export const APIInstitutionAdminList = BASE_URL + "/api/institution-admin/list";
export const APIInstitutionAdminDelete = BASE_URL + "/api/institution-admin/delete";
export const APIInstitutionAdminToggleStatus = BASE_URL + "/api/institution-admin/toggle-status";
export const APIInstitutionAdminProfileImage = BASE_URL+"/api/institution-admin/profile-image/";
export const APIInstitutionAdminUpdatePassword = BASE_URL+"/api/institution-admin/update-password";
export const APIInstitutionAdminUpdatePasswordByAdmin = BASE_URL+"/api/institution-admin/update-password-by-admin";



export const APIInstitutionAdminVerifyEmail = `${BASE_URL}/api/institution-admin/verify-email`;
export const APIInstitutionAdminResendVerification = `${BASE_URL}/api/institution-admin/resend-verification`;
export const APIInstitutionAdminForgotPassword = `${BASE_URL}/api/institution-admin/forgot-password`;
export const APIInstitutionAdminResetPassword = `${BASE_URL}/api/institution-admin/reset-password`;
export const APIInstitutionAdminVerifyResetToken = `${BASE_URL}/api/institution-admin/verify-reset-token`;


// Institution Head APIs
export const APIInstitutionAdminAllow = `${BASE_URL}/api/institution-head/allow-admin`;
export const APIInstitutionHeadRegister = BASE_URL + "/api/institution-head/register";
export const APIInstitutionHeadLogin = BASE_URL + "/api/institution-head/login";
export const APIInstitutionHeadProfileById = BASE_URL + "/api/institution-head/profile-by-id";
export const APIInstitutionHeadUpdate = BASE_URL + "/api/institution-head/update";
export const APIInstitutionHeadLogout = BASE_URL + "/api/institution-head/logout";
export const APIInstitutionHeadList = BASE_URL + "/api/institution-head/list";
export const APIInstitutionHeadDelete = BASE_URL + "/api/institution-head/delete";
export const APIInstitutionHeadProfileImage = BASE_URL + "/api/institution-head/profile-image/";
export const APIInstitutionHeadUpdatePassword = BASE_URL + "/api/institution-head/update-password";
export const APIInstitutionHeadUpdatePasswordByAdmin = BASE_URL + "/api/institution-head/update-password-by-admin";
export const APIInstitutionHeadVerifyEmail = BASE_URL + "/api/institution-head/verify-email";
export const APIInstitutionHeadResendVerification = BASE_URL + "/api/institution-head/resend-verification";
export const APIInstitutionHeadForgotPassword = BASE_URL + "/api/institution-head/forgot-password";
export const APIInstitutionHeadResetPassword = BASE_URL + "/api/institution-head/reset-password";
export const APIInstitutionHeadVerifyResetToken = BASE_URL + "/api/institution-head/verify-reset-token";
export const APIInstitutionHeadAdminList = BASE_URL + "/api/institution-head/admin-list";
export const APIInstitutionHeadAllow = `${BASE_URL}/api/institution-head/allow-head`;
export const APIInstitutionHeadProfileCompletion =BASE_URL + "/api/institution-head/profile-completion";

// Research Topic APIs
export const APIResearchTopicList = `${BASE_URL}/api/research-topic/list`;
export const APIResearchTopicBySupervisor = `${BASE_URL}/api/research-topic/by-supervisor`;
export const APIResearchTopicByUniversity = `${BASE_URL}/api/research-topic/by-university`;
export const APIResearchTopicByStudent = `${BASE_URL}/api/research-topic/by-student`;
export const APIResearchTopicStore = `${BASE_URL}/api/research-topic/store`;
export const APIResearchTopicUpdate = `${BASE_URL}/api/research-topic/update`;
export const APIResearchTopicCheckExists = `${BASE_URL}/api/research-topic/check-exists`;
export const APIResearchTopicDelete = `${BASE_URL}/api/research-topic/delete`;
export const APIResearchTopicShow = `${BASE_URL}/api/research-topic/show`;
export const APIResearchTopicSubmit = `${BASE_URL}/api/research-topic/submit`;
export const APIResearchTopicUpdateStatus = `${BASE_URL}/api/research-topic/update-status`;
export const APIResearchTopicUpdateApprovalStatus = `${BASE_URL}/api/research-topic/update-approval-status`;
export const APIResearchTopicMarkCompleted = `${BASE_URL}/api/research-topic/mark-completed`;
export const APIResearchTopicSupervisorsBySpecialty = `${BASE_URL}/api/research-topic/supervisors-by-specialty`;

// Topic Similarity APIs
export const APITopicSimilarityList = `${BASE_URL}/api/topic-similarity/list`;
export const APITopicSimilarityByTopic = `${BASE_URL}/api/topic-similarity/by-topic`;
export const APITopicSimilarityShow = `${BASE_URL}/api/topic-similarity/show`;
export const APITopicSimilarityStore = `${BASE_URL}/api/topic-similarity/store`;
export const APITopicSimilarityUpdate = `${BASE_URL}/api/topic-similarity/update`;
export const APITopicSimilarityDelete = `${BASE_URL}/api/topic-similarity/delete`;
export const APITopicSimilarityGenerateReport = `${BASE_URL}/api/topic-similarity/generate-report`;

// Supervisor Match APIs
export const APISupervisorMatchList = `${BASE_URL}/api/supervisor-match/list`;
export const APISupervisorMatchRecommendations = `${BASE_URL}/api/supervisor-match/recommendations`;
export const APISupervisorMatchStats = `${BASE_URL}/api/supervisor-match/stats`;
export const APISupervisorMatchShow = `${BASE_URL}/api/supervisor-match/show`;
export const APISupervisorMatchStore = `${BASE_URL}/api/supervisor-match/store`;
export const APISupervisorMatchUpdateChoice = `${BASE_URL}/api/supervisor-match/update-choice`;
export const APISupervisorMatchDelete = `${BASE_URL}/api/supervisor-match/delete`;


// Workflow APIs
export const APIWorkflowMilestones = `${BASE_URL}/api/work-flow/milestones`;
export const APIWorkflowTracking = `${BASE_URL}/api/work-flow/tracking`;
export const APIWorkflowStats = `${BASE_URL}/api/work-flow/stats`;
export const APIWorkflowUpdateMilestone = `${BASE_URL}/api/work-flow/update-milestone`;


// Feedback and Files APIs
export const APIFeedbackList = `${BASE_URL}/api/feed-back-files/feedback`;
export const APIFilesList = `${BASE_URL}/api/feed-back-files/files`;
export const APIUnreadCount = `${BASE_URL}/api/feed-back-files/unread-count`;
export const APIMarkFeedbackRead = `${BASE_URL}/api/feed-back-files/mark-read`;
export const APIAcknowledgeFeedback = `${BASE_URL}/api/feed-back-files/acknowledge`;
export const APIUploadFile = `${BASE_URL}/api/feed-back-files/upload`;
export const APIDeleteFile = `${BASE_URL}/api/feed-back-files/delete-file`;

// Publication APIs
export const APIPublicationList = `${BASE_URL}/api/publication/list`;
export const APIPublicationStats = `${BASE_URL}/api/publication/stats`;
export const APIPublicationStore = `${BASE_URL}/api/publication/store`;
export const APIPublicationUpdate = `${BASE_URL}/api/publication/update`;
export const APIPublicationDelete = `${BASE_URL}/api/publication/delete`;

// Research Work APIs
export const APIResearchWorkList = `${BASE_URL}/api/research-work-upload/list`;
export const APIResearchWorkListByUniversity = `${BASE_URL}/api/research-work-upload/by-university`;
export const APIResearchWorkListBySupervisor = `${BASE_URL}/api/research-work-upload/by-supervisor`;
export const APIResearchWorkListByStudent = `${BASE_URL}/api/research-work-upload/by-student`;
export const APIResearchWorkStore = `${BASE_URL}/api/research-work-upload/store`;
export const APIResearchWorkUpdate = `${BASE_URL}/api/research-work-upload/update`;
export const APIResearchWorkSubmitReview = `${BASE_URL}/api/research-work-upload/submit-review`;
export const APIResearchWorkDelete = `${BASE_URL}/api/research-work-upload/delete`;
export const APIResearchWorkReviewStore =  `${BASE_URL}/api/research-work-upload/research-work-review`;
export const APIResearchWorkUploadRevision = `${BASE_URL}/api/research-work-upload/upload-revision`;




















// Notification APIs
export const APINotificationList = `${BASE_URL}/api/notification/list`;
export const APINotificationUnread = `${BASE_URL}/api/notification/unread`;
export const APINotificationStats = `${BASE_URL}/api/notification/stats`;
export const APINotificationUnreadCount = `${BASE_URL}/api/notification/unread-count`;
export const APINotificationMarkRead = `${BASE_URL}/api/notification/mark-read`;
export const APINotificationMarkAllRead = `${BASE_URL}/api/notification/mark-all-read`;
export const APINotificationStore = `${BASE_URL}/api/notification/store`;
export const APINotificationDelete = `${BASE_URL}/api/notification/delete`;


//  ======================================================
// Supervisor start 
//  ======================================================
// Supervisor Assignment APIs
export const APISupervisorAssignmentList = `${BASE_URL}/api/supervisor-assignment/list`;
export const APISupervisorAssignmentStats = `${BASE_URL}/api/supervisor-assignment/stats`;
export const APISupervisorAssignmentUpdateStatus = `${BASE_URL}/api/supervisor-assignment/update-status`;
export const APISupervisorAssignmentUpdateRelationship = `${BASE_URL}/api/supervisor-assignment/update-relationship`;
export const APISupervisorAssignmentScheduleMeeting = `${BASE_URL}/api/supervisor-assignment/schedule-meeting`;
export const APISupervisorAssignmentUpdateInteraction = `${BASE_URL}/api/supervisor-assignment/update-interaction`;


// Review APIs
export const APIReviewList = `${BASE_URL}/api/review/list`;
export const APIReviewStats = `${BASE_URL}/api/review/stats`;
export const APIReviewStart = `${BASE_URL}/api/review/start`;
export const APIReviewSubmit = `${BASE_URL}/api/review/submit`;
export const APIReviewEscalate = `${BASE_URL}/api/review/escalate`;
export const APIReviewUpdateUrgency = `${BASE_URL}/api/review/update-urgency`;


// Supervision Capacity APIs
export const APISupervisionCapacityMetrics = `${BASE_URL}/api/supervision-capacity/metrics`;
export const APISupervisionCapacityRecommendations = `${BASE_URL}/api/supervision-capacity/recommendations`;
export const APISupervisionCapacityUpdate = `${BASE_URL}/api/supervision-capacity/update-capacity`;
export const APISupervisionCapacityRequestChange = `${BASE_URL}/api/supervision-capacity/request-change`;
export const APISupervisionCapacityUpdateWorkload = `${BASE_URL}/api/supervision-capacity/update-workload`;
export const APISupervisionCapacityRequestLeave = `${BASE_URL}/api/supervision-capacity/request-leave`;

// Research Performance APIs
export const APIResearchPerformanceMetrics = `${BASE_URL}/api/research-performance/metrics`;
export const APIResearchPerformanceStats = `${BASE_URL}/api/research-performance/stats`;


// Supervisor Dashboard APIs
export const APISupervisorDashboard = `${BASE_URL}/api/supervisor-dashboard/data`;


// Student Feedback APIs
export const APIStudentFeedbackList = `${BASE_URL}/api/student-feedback/list`;
export const APIStudentFeedbackAnalytics = `${BASE_URL}/api/student-feedback/analytics`;
export const APIStudentFeedbackSubmitResponse = `${BASE_URL}/api/student-feedback/submit-response`;


//  ======================================================
// Supervisor end
//  ======================================================


//  ======================================================
// University Admin start
//  ======================================================

// User Management APIs
export const APIUserManagementList = `${BASE_URL}/api/user-management/users`;
export const APIUserManagementLogs = `${BASE_URL}/api/user-management/logs`;
export const APIUserManagementStats = `${BASE_URL}/api/user-management/stats`;
export const APIUserManagementUpdateStatus = `${BASE_URL}/api/user-management/update-status`;
export const APIUserManagementApprove = `${BASE_URL}/api/user-management/approve`;
export const APIUserManagementReject = `${BASE_URL}/api/user-management/reject`;
export const APIUserManagementResetPassword = `${BASE_URL}/api/user-management/reset-password`;
export const APIUserManagementByUniversity = `${BASE_URL}/api/user-management/by-university`;
export const APIUserManagementUniversityStats = `${BASE_URL}/api/user-management/university-stats`;

// Supervisor Approval APIs
export const APISupervisorApprovalList = `${BASE_URL}/api/supervisor-approval/list`;
export const APISupervisorApprovalByUniversity = `${BASE_URL}/api/supervisor-approval/by-university`;
export const APISupervisorApprovalStats = `${BASE_URL}/api/supervisor-approval/stats`;
export const APISupervisorApprovalShow = `${BASE_URL}/api/supervisor-approval/show`;
export const APISupervisorApprovalUpdateVerification = `${BASE_URL}/api/supervisor-approval/update-verification`;
export const APISupervisorApprovalUpdateApproval = `${BASE_URL}/api/supervisor-approval/update-approval`;

// Student Approval APIs
export const APIStudentApprovalList = `${BASE_URL}/api/student-approval/list`;
export const APIStudentApprovalByUniversity = `${BASE_URL}/api/student-approval/by-university`;
export const APIStudentApprovalStats = `${BASE_URL}/api/student-approval/stats`;
export const APIStudentApprovalShow = `${BASE_URL}/api/student-approval/show`;
export const APIStudentApprovalUpdateVerification = `${BASE_URL}/api/student-approval/update-verification`;
export const APIStudentApprovalUpdateApproval = `${BASE_URL}/api/student-approval/update-approval`;


// Topic Oversight APIs
export const APITopicOversightList = `${BASE_URL}/api/topic-oversight/list`;
export const APITopicOversightStats = `${BASE_URL}/api/topic-oversight/stats`;
export const APITopicOversightUpdateOversight = `${BASE_URL}/api/topic-oversight/update-oversight`;
export const APITopicOversightUpdateDepartmental = `${BASE_URL}/api/topic-oversight/update-departmental`;
export const APITopicOversightUpdateEthics = `${BASE_URL}/api/topic-oversight/update-ethics`;
export const APITopicOversightUpdateFinal = `${BASE_URL}/api/topic-oversight/update-final`;


// Institution Settings APIs
export const APIInstitutionSettingsList = `${BASE_URL}/api/institution-settings/list`;
export const APIInstitutionSettingsUpdate = `${BASE_URL}/api/institution-settings/update`;
export const APIInstitutionSettingsResetDefault = `${BASE_URL}/api/institution-settings/reset-default`;
export const APIInstitutionSettingsToggleStatus = `${BASE_URL}/api/institution-settings/toggle-status`;

// Assign Supervisor APIs
export const APIAssignStudentList = `${BASE_URL}/api/assign-student/list`;
export const APIAssignStudentBySupervisor = `${BASE_URL}/api/assign-student/by-supervisor`;
export const APIAssignStudentByStudent = `${BASE_URL}/api/assign-student/by-student`;
export const APIAssignStudentByUniversity = `${BASE_URL}/api/assign-student/by-university`;
export const APIAssignStudentStore = `${BASE_URL}/api/assign-student/store`;
export const APIAssignStudentUpdate = `${BASE_URL}/api/assign-student/update`;
export const APIAssignStudentUpdateReAssign = `${BASE_URL}/api/assign-student/re-assign-supervisor`;
export const APIAssignStudentUpdateStatus = `${BASE_URL}/api/assign-student/update-status`;
export const APIAssignStudentDelete = `${BASE_URL}/api/assign-student/delete`;
export const APIAssignStudentShow = `${BASE_URL}/api/assign-student/show`;
export const APIAssignStudentStats = `${BASE_URL}/api/assign-student/stats`;
export const APIAssignStudentStatsBySupervisor = `${BASE_URL}/api/assign-student/stats/by-supervisor`;
export const APIUnassignedStudents = `${BASE_URL}/api/assign-student/unassigned-students`;
export const APIAvailableSupervisors = `${BASE_URL}/api/assign-student/available-supervisors`;


// Assign Supervisor APIs (use these consistently)
export const APIAssignStudentUpdateRelationship = `${BASE_URL}/api/assign-student/update-relationship`;
export const APIAssignStudentScheduleMeeting = `${BASE_URL}/api/assign-student/schedule-meeting`;
export const APIAssignStudentUpdateInteraction = `${BASE_URL}/api/assign-student/update-interaction`;


//  ======================================================
// University Admin end
//  ======================================================



//  ======================================================
// Platform Admin start
//  ======================================================

// Cross-Institution Analytics APIs
export const APICrossInstitutionAnalyticsDashboard = `${BASE_URL}/api/cross-institution-analytics/dashboard`;
export const APICrossInstitutionAnalyticsInstitution = `${BASE_URL}/api/cross-institution-analytics/institution`;


// Topic Similarity APIs
export const APINationalTopicTrends = `${BASE_URL}/api/national-topic-similarity/trends`;
export const APINationalTopicSimilarity = `${BASE_URL}/api/national-topic-similarity/similarity`;
export const APINationalTopicCountryDistribution = `${BASE_URL}/api/national-topic-similarity/country-distribution`;
export const APINationalTopicTrendingKeywords = `${BASE_URL}/api/national-topic-similarity/trending-keywords`;
export const APINationalTopicRunAnalysis = `${BASE_URL}/api/national-topic-similarity/run-analysis`;


// Supervisor Rankings APIs
// export const APISupervisorRankingList = `${BASE_URL}/api/supervisor-rankings/list`;
export const APISupervisorRankingTopPerformers = `${BASE_URL}/api/supervisor-rankings/top-performers`;
export const APISupervisorRankingCalculate = `${BASE_URL}/api/supervisor-rankings/calculate`;
// export const APISupervisorRankingFinalize = `${BASE_URL}/api/supervisor-rankings/finalize`;


// Supervisor Rankings APIs
export const APISupervisorRankingList = `${BASE_URL}/api/supervisor-rankings/supervisors`;
export const APISupervisorRankingSubmit = `${BASE_URL}/api/supervisor-rankings/submit`;
export const APISupervisorRankingStatus = `${BASE_URL}/api/supervisor-rankings/status`;
export const APISupervisorRankingBySpecialty = `${BASE_URL}/api/supervisor-rankings/by-specialty`;
export const APISupervisorRankingSupervisor = `${BASE_URL}/api/supervisor-rankings/supervisor`;
export const APISupervisorRankingVerify = `${BASE_URL}/api/supervisor-rankings/verify`;
export const APISupervisorRankingFinalize = `${BASE_URL}/api/supervisor-rankings/finalize`;

// Supervisor Specialties by Institution
export const APISupervisorSpecialtiesByInstitution = `${BASE_URL}/api/specialties/by-institution`;


//  Notifications
export const APIPlatformAdminNotifications = `${BASE_URL}/api/platform-admin/notifications/list`;
export const APIPlatformAdminNotificationsRecent = `${BASE_URL}/api/platform-admin/notifications/recent`;
export const APIPlatformAdminNotificationsStatistics = `${BASE_URL}/api/platform-admin/notifications/statistics`;
export const APIPlatformAdminNotificationsMarkRead = (id) => `${BASE_URL}/api/platform-admin/notifications/${id}/read`;
export const APIPlatformAdminNotificationsMarkAllRead = `${BASE_URL}/api/platform-admin/notifications/mark-all-read`;
export const APIPlatformAdminNotificationsDelete = (id) => `${BASE_URL}/api/platform-admin/notifications/${id}`;
export const APIPlatformAdminNotificationsBulkDelete = `${BASE_URL}/api/platform-admin/notifications/bulk-delete`;


// Student Notifications
export const APIStudentNotifications = `${BASE_URL}/api/student/notifications/list`;
export const APIStudentNotificationsRecent = `${BASE_URL}/api/student/notifications/recent`;
export const APIStudentNotificationsStatistics = `${BASE_URL}/api/student/notifications/statistics`;
export const APIStudentNotificationsMarkRead = (id) => `${BASE_URL}/api/student/notifications/${id}/read`;
export const APIStudentNotificationsMarkAllRead = `${BASE_URL}/api/student/notifications/mark-all-read`;
export const APIStudentNotificationsDelete = (id) => `${BASE_URL}/api/student/notifications/${id}`;
export const APIStudentNotificationsBulkDelete = `${BASE_URL}/api/student/notifications/bulk-delete`;



// Institution Admin Notifications
export const APIInstitutionAdminNotifications = `${BASE_URL}/api/institution-admin/notifications/list`;
export const APIInstitutionAdminNotificationsRecent = `${BASE_URL}/api/institution-admin/notifications/recent`;
export const APIInstitutionAdminNotificationsStatistics = `${BASE_URL}/api/institution-admin/notifications/statistics`;
export const APIInstitutionAdminNotificationsMarkRead = (id) => `${BASE_URL}/api/institution-admin/notifications/${id}/read`;
export const APIInstitutionAdminNotificationsMarkAllRead = `${BASE_URL}/api/institution-admin/notifications/mark-all-read`;
export const APIInstitutionAdminNotificationsDelete = (id) => `${BASE_URL}/api/institution-admin/notifications/${id}`;
export const APIInstitutionAdminNotificationsBulkDelete = `${BASE_URL}/api/institution-admin/notifications/bulk-delete`;

// Institution Head Notifications
export const APIInstitutionHeadNotifications = `${BASE_URL}/api/institution-head/notifications/list`;
export const APIInstitutionHeadNotificationsRecent = `${BASE_URL}/api/institution-head/notifications/recent`;
export const APIInstitutionHeadNotificationsStatistics = `${BASE_URL}/api/institution-head/notifications/statistics`;
export const APIInstitutionHeadNotificationsMarkRead = (id) => `${BASE_URL}/api/institution-head/notifications/${id}/read`;
export const APIInstitutionHeadNotificationsMarkAllRead = `${BASE_URL}/api/institution-head/notifications/mark-all-read`;
export const APIInstitutionHeadNotificationsDelete = (id) => `${BASE_URL}/api/institution-head/notifications/${id}`;
export const APIInstitutionHeadNotificationsBulkDelete = `${BASE_URL}/api/institution-head/notifications/bulk-delete`;



// Supervisor Notifications
export const APISupervisorNotifications = `${BASE_URL}/api/supervisor/notifications/list`;
export const APISupervisorNotificationsRecent = `${BASE_URL}/api/supervisor/notifications/recent`;
export const APISupervisorNotificationsStatistics = `${BASE_URL}/api/supervisor/notifications/statistics`;
export const APISupervisorNotificationsMarkRead = (id) => `${BASE_URL}/api/supervisor/notifications/${id}/read`;
export const APISupervisorNotificationsMarkAllRead = `${BASE_URL}/api/supervisor/notifications/mark-all-read`;
export const APISupervisorNotificationsDelete = (id) => `${BASE_URL}/api/supervisor/notifications/${id}`;
export const APISupervisorNotificationsBulkDelete = `${BASE_URL}/api/supervisor/notifications/bulk-delete`;
// Assigned Students by Supervisor
export const APIAssignedStudentsBySupervisor = (supervisorId) => `${BASE_URL}/api/assigned-students/by-supervisor/${supervisorId}`;
//  ======================================================
// Platform Admin end
//  ======================================================


// Message APIs
export const APIAssignStudentMessages = `${BASE_URL}/api/messages/assignment`;
export const APIAssignStudentSendMessage = `${BASE_URL}/api/messages/send`;
export const APIAssignStudentMarkRead = `${BASE_URL}/api/messages/mark-read`;
export const APIAssignStudentUnreadCount = `${BASE_URL}/api/messages/unread-count`;